<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>
    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>
    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div v-show="showUI" class="margin_top_20">
      <div class="dropdown_container" v-show="isFieldNeeded('education_level')">
        <wxc-dropdown
          default-item="Select"
          :title="getFieldLabel('education_level')"
          :select-item="getFieldValue('education_level')"
          :config="dropdownConfig"
          :list="educationLevelOptions"
          @onItemSelected="onInputEntered('education_level', $event.value)"
        ></wxc-dropdown>
        <field-error-item
          :show-error="showFieldError('education_level')"
          :error-msg="getErrorMsg('education_level')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('email')">
        <weex-text class="input_label">{{getFieldLabel('email')}}</weex-text>
        <input
          class="input_with_border_bottom"
          type="email"
          :value="getFieldValue('email')"
          @input="onInputEntered('email', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('email')"
          :error-msg="getErrorMsg('email')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('phone_number')">
        <weex-text class="input_label">{{getFieldLabel('phone_number')}}</weex-text>
        <input
          class="input_with_border_bottom"
          type="number"
          :value="getFieldValue('phone_number')"
          @input="onInputEntered('phone_number', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('phone_number')"
          :error-msg="getErrorMsg('phone_number')"
        ></field-error-item>
      </div>

    <div class="input_container" v-if="isFieldNeeded('employer_name') && !showEmployerSuggestion">
      <weex-text class="input_label">{{getFieldLabel('employer_name')}}</weex-text>
      <input
        class="input_with_border_bottom"
        :value="getFieldValue('employer_name')"
        @input="onInputEntered('employer_name', $event.target.value)"
        return-key-type="next">
      <field-error-item
        :show-error="showFieldError('employer_name')"
        :error-msg="getErrorMsg('employer_name')"
      ></field-error-item>
    </div>

    <div class="input_container" v-if="isFieldNeeded('employer_name') && showEmployerSuggestion">
      <weex-text class="input_label">{{getFieldLabel('employer_name')}}</weex-text>
      <vue-simple-suggest
        v-model="selectedEmployerName"
        :list="getEmployerSuggestionList"
        :max-suggestions="10"
        :min-length="3"
        @select="employerSearchSuggestionclicked"
      ></vue-simple-suggest>
      <field-error-item
        :show-error="showFieldError('employer_name')"
        :error-msg="getErrorMsg('employer_name')"
      ></field-error-item>
    </div>

    <div class="input_container" v-if="isFieldNeeded('employer_name') && showEmployerSuggestion && isEmployerNameOther">
      <weex-text class="input_label">Enter your Company Name</weex-text>
      <input
        class="input_with_border_bottom"
        @input="onInputEntered('employer_name', $event.target.value)"
        return-key-type="next">
    </div>


      <div class="dropdown_container" v-show="isFieldNeeded('company_type')">
        <wxc-dropdown
          default-item="Select"
          :title="getFieldLabel('company_type')"
          :select-item="getFieldValue('company_type')"
          :config="dropdownConfig"
          :list="companyTypeOptions"
          @onItemSelected="onInputEntered('company_type', $event.value)"
        ></wxc-dropdown>
        <field-error-item
          :show-error="showFieldError('company_type')"
          :error-msg="getErrorMsg('company_type')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('designation')">
        <weex-text class="input_label">{{getFieldLabel('designation')}}</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('designation')"
          @input="onInputEntered('designation', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('designation')"
          :error-msg="getErrorMsg('designation')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('years_in_job')">
        <weex-text class="input_label">{{getFieldLabel('years_in_job')}}</weex-text>
        <input
          class="input_with_border_bottom"
          type="number"
          maxlength="2"
          :value="getFieldValue('years_in_job')"
          @input="onInputEntered('years_in_job', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('years_in_job')"
          :error-msg="getErrorMsg('years_in_job')"
        ></field-error-item>
      </div>


      <div
        v-if="isFieldNeeded('years_in_current_job') || isFieldNeeded('months_in_current_job')"
        class="item-row-alignment margin_top_20">

        <div v-if="isFieldNeeded('years_in_current_job')"
             style="width: 50%; margin: 0 5px 0 10px">
          <weex-text class="input_label">{{getFieldLabel('years_in_current_job')}}</weex-text>
          <input
            class="input_with_border_bottom"
            type="number"
            maxlength="2"
            :value="getFieldValue('years_in_current_job')"
            @input="onInputEntered('years_in_current_job', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('years_in_current_job')"
            :error-msg="getErrorMsg('years_in_current_job')"
          ></field-error-item>
        </div>

        <div v-if="isFieldNeeded('months_in_current_job')"
             style="width: 50%; margin: 0 10px 0 5px">
          <weex-text class="input_label">{{getFieldLabel('months_in_current_job')}}</weex-text>
          <input
            class="input_with_border_bottom"
            type="number"
            maxlength="2"
            :value="getFieldValue('months_in_current_job')"
            @input="onInputEntered('months_in_current_job', $event.target.value)"
            return-key-type="next">
          <field-error-item
            :show-error="showFieldError('months_in_current_job')"
            :error-msg="getErrorMsg('months_in_current_job')"
          ></field-error-item>
        </div>
      </div>

      <wxc-button
        size="full"
        text="Next"
        class="horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>

    </div>
  </div>
</template>
<script>

import ToolBar from "../../layout/ToolBar";
import Loading from "../../layout/Loading";
import StageCommentItem from "../../layout/StageCommentItem";
import ErrorAlertItem from "../../layout/ErrorAlertItem";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import FieldErrorItem from "../../layout/FieldErrorItem";
import RefreshItem from "../../layout/RefreshItem";
import WxcDropdown from "../../../../weex-ui/packages/wxc-dropdown/index";
import WxcButton from "../../../../weex-ui/packages/wxc-button/index";
import DataSource from "../../../data/DataSource";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import { DataTables } from "../../../utils/DataTables";
import EzUtils from "../../../utils/EzUtils";
import DataTableUtils from "../../../utils/DataTableUtils";
import LoanTasksActivityNavigator from "../../../utils/LoanTasksActivityNavigator";
import { DefaultResourceConfig } from "../../../utils/ImageResourcesUtil";
import { MessageConstants } from "../../../utils/MessageConstantUtil";
import { Activities } from "../../../utils/ActivityNavigator";
import AlertService from "../../core/alert/AlertService";
import { ValidationPatterns } from "../../../utils/ValidationPatterns";
import DynamicFieldUtils, { FieldTypes } from "../../../utils/DynamicFieldUtils";
import storageUtil from "../../../utils/StorageUtil";
import VueSimpleSuggest from 'vue-simple-suggest'
import AttributeUtil from "../../../utils/AttributeUtil";
import {Constants} from "../../Constants";

const ALL_FIELDS_DATA = {
  education_level: {
    label: "Education Level",
    validation: "",
    fieldType: FieldTypes.DROPDOWN,
    errorMsg: "Please select Education Level.",
    optional: false
  },

  email: {
    label: "Company/Business Email",
    validation: ValidationPatterns.EMAIL_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid Email.",
    optional: false
  },

  phone_number: {
    label: "Phone Number",
    validation: ValidationPatterns.PHONE_NUMBER_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid Phone Number.",
    optional: false
  },

  employer_name: {
    label: "Company Name",
    validation: "",
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter Company Name.",
    optional: false
  },

  company_type: {
    label: "Type of Company",
    validation: "",
    fieldType: FieldTypes.DROPDOWN,
    errorMsg: "Please select Company Type.",
    optional: false
  },

  designation: {
    label: "Designation",
    validation: "",
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter Designation.",
    optional: false
  },

  years_in_current_job: {
    label: "Years in current job",
    validation: ValidationPatterns.YEARS_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Enter valid no of Years.",
    optional: false
  },

  months_in_current_job: {
    label: "Months in current job",
    validation: ValidationPatterns.MONTHS_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Allowed value: 0-11.",
    optional: false
  },

  years_in_job: {
    label: "Years of Experience",
    validation: ValidationPatterns.YEARS_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Enter valid no of Years.",
    optional: false
  }
};

export default {
  name: "AdditionalProfessionalDetailsActivity",
  components: {
    ActivityRedirectItem,
    ToolBar,
    WxcButton,
    Loading,
    WxcDropdown,
    StageCommentItem,
    ErrorAlertItem,
    RefreshItem,
    FieldErrorItem,
    VueSimpleSuggest
  },
  data: () => ({
    toolbarTitle: "Professional Details",
    professionalDetails: {
      education_level: null,
      company_type: null,
      email: null,
      phone_number: null,
      designation: null,
      employer_name: null,
      years_in_current_job: null,
      months_in_current_job: null,
      years_in_job: null
    },
    educationLevelOptions: [],
    companyTypeOptions: [],
    rowId: -1,
    showUI: false,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    dynamicFields: null,
    invalidFields: [],
    selectedEmployerName: "",
    showEmployerSuggestion: false,
    isEmployerNameOther: false,
  }),
  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    isFieldNeeded(key) {
      return this.dynamicFields == null || this.dynamicFields[key] != null;
    },

    getFieldLabel(key) {
      if (this.dynamicFields && this.dynamicFields[key] && this.dynamicFields[key]["label"]) {
        return this.dynamicFields[key]["label"];
      }
      return ALL_FIELDS_DATA[key]["label"];
    },

    showFieldError(fieldKey) {
      return this.invalidFields && this.invalidFields.includes(fieldKey);
    },

    getErrorMsg(fieldKey) {
      return ALL_FIELDS_DATA[fieldKey]["errorMsg"];
    },

    getFieldValue(key) {
      return this.professionalDetails ? this.professionalDetails[key] : "";
    },

    onInputEntered(key, value) {
      this.professionalDetails[key] = value;
      this.removeFromInvalidFieldsIfValid(key);
    },

    removeFromInvalidFieldsIfValid(key) {
      this.invalidFields = DynamicFieldUtils.removeFromInvalidFieldsIfValidValue(
        this.invalidFields,
        key,
        this.professionalDetails[key],
        ALL_FIELDS_DATA,
        this.dynamicFields
      );
    },

    onSubmit() {
      if (this.checkForValidation()) {
        if(this.showEmployerSuggestion) {
          this.createOrUpdateEmployerNameApprovedAttributeAndSaveProfessionalDetails();
        } else {
          this.saveProfessionalDetails();
        }
      }
    },

    checkForValidation() {
      this.invalidFields = DynamicFieldUtils.validateDynamicFieldsForRequiredFields(
        this.professionalDetails,
        ALL_FIELDS_DATA,
        this.dynamicFields
      );

      const dataValid = !this.invalidFields || this.invalidFields.length === 0;

      if (dataValid
        && this.isFieldNeeded("years_in_current_job")
        && this.isFieldNeeded("years_in_job")
        && parseInt(this.getFieldValue("years_in_current_job")) >
        parseInt(this.getFieldValue("years_in_job"))
      ) {
        this.showToast(MessageConstants.INVALID_EXPERIENCE_MESSAGE);
        return false;
      }

      return dataValid;
    },

    saveProfessionalDetails() {
      this.loading = true;
      if (EzUtils.isValidId(this.rowId)) {
        DataSource.updateDataTableEntryInMultiRowDataTable(
          DataTables.PROFESSIONAL_DETAILS,
          LoanScopeDataHolder.getClientId(),
          this.rowId,
          this.professionalDetails
        )
          .then(res => {
            if (res.errorOccurred) {
              this.showError(res.data);
            } else {
              this.getNextTask();
            }
          })
      } else {
        DataSource.addDataTableEntry(
          DataTables.PROFESSIONAL_DETAILS,
          LoanScopeDataHolder.getClientId(),
          this.professionalDetails
        )
          .then(res => {
            if (res.errorOccurred) {
              this.showError(res.data);
            } else {
              this.getNextTask();
            }
          })
      }
    },

    getNextTask() {
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getDataTableByDataTableName(DataTables.PROFESSIONAL_DETAILS)
        .then(dataTableRes => {
          if (dataTableRes.errorOccurred) {
            this.showError(dataTableRes.data);
            this.showRefreshItem = true;
          } else {
            const educationLevelOptions = DataTableUtils.getOptionsList(
              dataTableRes.data,
              "education_level"
            );
            educationLevelOptions && educationLevelOptions.forEach(educationLevelOption => {
              if (educationLevelOption) {
                this.educationLevelOptions.push({
                  title: educationLevelOption,
                  value: educationLevelOption
                });
              }
            });

            const companyTypeOptions = DataTableUtils.getOptionsList(
              dataTableRes.data,
              "company_type"
            );

            companyTypeOptions && companyTypeOptions.forEach(companyTypeOption => {
              if (companyTypeOption) {
                this.companyTypeOptions.push({
                  title: companyTypeOption,
                  value: companyTypeOption
                });
              }
            });

            DataSource.getDataTableInfo(
              DataTables.PROFESSIONAL_DETAILS,
              LoanScopeDataHolder.getClientId()
            )
              .then(res => {
                this.loading = false;
                if (res.errorOccurred) {
                  this.showError(res.data);
                  this.showRefreshItem = true;
                } else {
                  if (EzUtils.isNotEmpty(res.data)) {
                    const details = res.data[0];
                    this.rowId = details.id;
                    this.onInputEntered("education_level", details.education_level);
                    this.onInputEntered("company_type", details.company_type);
                    this.onInputEntered("email", details.email);
                    this.onInputEntered("phone_number", details.phone_number);
                    this.onInputEntered("employer_name", details.employer_name);
                    this.onInputEntered("designation", details.designation);
                  }
                  this.showUI = true;
                }
              });
          }
        });
        DataSource.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
            this.showRefreshItem = true;
          } else {
            if(res.data.properties){
              this.showEmployerSuggestion  = res.data.properties.show_employer_list_suggestion;
              if(this.showEmployerSuggestion){
                this.selectedEmployerName = this.getFieldValue('employer_name');
              }
            }
          }
        });
    },

    getEmployerSuggestionList() {
      return DataSource.getEmployerList(LoanScopeDataHolder.getLoanId(),this.selectedEmployerName)
      .then(res => {
        if (!res.errorOccurred) {
          return res.data;
        }
      });

    },

    employerSearchSuggestionclicked(event){
      if("Other" === event) {
        this.isEmployerNameOther = true;
        this.onInputEntered('employer_name', "");
      } else {
        this.isEmployerNameOther = false;
        this.onInputEntered('employer_name', event);
      }
    },

    createOrUpdateEmployerNameApprovedAttributeAndSaveProfessionalDetails() {
      this.loading = true;
      DataSource.createOrUpdateAttribute(
          AttributeUtil.getAttributeUpdateDto(
              Constants.LOANS,
              LoanScopeDataHolder.getLoanId(),
              AttributeUtil.getSingleAttributeData(
                  "employer.name.approved",
                  "Employer Name Approved",
                  !this.isEmployerNameOther
              )
          )
      )
          .then(res => {
            if (res.errorOccurred) {
              this.showError(res.data)
            } else {
              this.saveProfessionalDetails();
            }
          })
    }

  },

  created: function () {
    this.dynamicFields = DynamicFieldUtils.getRequiredDynamicFieldsData();
  },

  mounted() {
    this.fetchInitialData();
  },

  computed: {
    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.PROFESSIONAL_ADDITIONAL];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },
  }
}
</script>

<style scoped src="../../../assets/style/base.css"></style>
<style src="../../../assets/style/vue-simple-suggest.css"></style>
